var data = {
	"body": "<path d=\"M12 11a4 4 0 1 0-4-4a4 4 0 0 0 4 4zm6 10a1 1 0 0 0 1-1a7 7 0 0 0-14 0a1 1 0 0 0 1 1z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
